<template>
  <div>
    <tabs :tabs="tabs" :entity-type="entityType" :entity-id="entityId" />

    <w-button
      v-if="previousFullPath && tabsNames.includes($route.name)"
      icon="fal fa-arrow-left"
      class="btn-light"
      text="Wróć"
      @click="goBack"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Tabs from '@/components/tabs/Tabs';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Storage } from '@/enums/storage.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { getDocumentDetails } from '@/utils/document';

// @vuese
// Szczegóły dokumentu
// @group Document
export default {
  components: { Tabs },
  mixins: [notificationsMixin],
  data() {
    return {
      entityType: EntityType.DOCUMENT,
      entityId: this.$route.params.documentId.toString(),
      previousFullPath: localStorage.getItem(Storage.PREVIOUS_FULL_PATH)
    };
  },
  computed: {
    ...mapState({
      docIndex: state => state.documentIndex.data,
      statuses: state => state.document.status.list,
      structureNodes: state => state.auth.nodes?.map(node => node.id),
      childProcedureId: state =>
        state.setting.settings[PublicSettings.CHILD_PROCEDURE_ID] &&
        state.setting.settings[PublicSettings.CHILD_PROCEDURE_ID].value,
      hideDocumentationJO: state =>
        state.setting.settings[PublicSettings.HIDE_DOCUMENT_DOCUMENTATION_FOR_JO]?.value === 'true',
      isCreator(state) {
        return state.auth.data.id === this.docIndex.creatorId;
      }
    }),
    procedureId() {
      return this.$route.params.procedureId;
    },
    tabs() {
      const structure = this.docIndex.data?.school?.nodeId;
      const tabs = [
        { title: 'Szczegóły', route: { name: 'documentView' }, permissions: ['DOCUMENT.GET'] },
        { title: 'Uwagi', route: { name: 'documentErrors', permissions: ['DOCUMENT.GET'] } },
        { title: 'Historia', route: { name: 'documentHistory' }, permissions: ['HISTORY.LIST'] },
        {
          title: 'Załączniki',
          route: { name: 'documentAttachments' },
          permissions: ['ATTACHMENT.LIST', 'ATTACHMENT.ADD'],
          entityType: structure ? EntityType.STRUCTURE_NODE : EntityType.PROCEDURE,
          entityId: structure ? structure.toString() : this.procedureId.toString(),
          noPermission: this.isCreator
            ? {
                title: 'Załączniki',
                route: { name: 'documentCreatorAttachments' },
                permissions: ['ATTACHMENT.LIST', 'ATTACHMENT.ADD'],
                entityType: EntityType.DOCUMENT,
                entityId: this.entityId
              }
            : undefined
        },
        {
          title: 'Wartości systemowe',
          route: { name: 'documentValues' },
          permissions: ['DOCUMENT_VALUE.LIST', 'DOCUMENT_VALUE.UPDATE']
        },
        {
          title: 'Numery systemowe',
          route: { name: 'documentSystemNumbers' },
          permissions: ['DOCUMENT.UPDATE_SYSTEM_NUMBERS']
        }
      ];

      if (!(this.hideDocumentationJO && this.structureNodes?.length)) {
        tabs.push({
          title: 'Dokumentacja',
          route: { name: 'documentDocumentation' },
          permissions: ['ATTACHMENT.DOCUMENTATION'],
          entityType: EntityType.DOCUMENT,
          entityId: this.entityId
        });
      }

      if (this.statuses.length > 0) {
        tabs.push({
          title: 'Wyniki oceny',
          route: { name: 'documentAssessmentSummary' },
          permissions: ['ASSESSMENT.LIST', 'CRITERION.LIST', 'DOCUMENT.GET']
        });
      }
      if (this.childProcedureId) {
        tabs.push({
          title: 'Ocena',
          route: {
            name: 'documentList',
            params: { procedureId: this.childProcedureId },
            query: {
              parentId: this.$route.params.documentId,
              parentProcedureId: this.$route.params.procedureId,
              statusId: undefined,
              tabId: undefined
            }
          },
          permissions: ['DOCUMENT.LIST'],
          entityType: EntityType.PROCEDURE,
          entityId: this.childProcedureId
        });
      }
      return tabs;
    },
    tabsNames() {
      return this.tabs ? this.tabs.map(tab => tab.route.name) : [];
    }
  },
  methods: {
    // @vuese
    // Powrót do poprzedniego widoku
    goBack() {
      this.$router.push({
        path: this.previousFullPath
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    getDocumentDetails(to)
      .then(() => next())
      .catch(err => this.notifyError(Errors.DOCUMENT_CANNOT_GET));
  }
};
</script>
